<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">

      <div v-loading="addressloading">    
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item v-if="provincelists.length > 0" style="width:15%">
            <el-select v-model="query.provinceid" filterable clearable placeholder="请选择省份" @change="changeprovince">	          
              <el-option v-for="(item,index) in provincelists" :label="item.showname" :value="item.id" :key="index">
                  <span style="float: left;margin-right:10%;font-size: 13px">{{item.py}}</span>
                  <span style="float: left">{{item.name}}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="citylists.length > 0" style="width:15%">
            <el-select v-model="query.cityid" filterable clearable placeholder="请选择市区" @change="changecity">	          
              <el-option v-for="(item,index) in citylists" :label="item.showname" :value="item.id" :key="index">
                  <span style="float: left;margin-right:10%;font-size: 13px">{{item.py}}</span>
                  <span style="float: left">{{item.name}}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="townlists.length > 0" style="width:15%">
            <el-select v-model="query.townid" filterable clearable placeholder="请选择区域/县城" @change="changetown">	          
              <el-option v-for="(item,index) in townlists" :label="item.showname" :value="item.id" :key="index">
                  <span style="float: left;margin-right:10%;font-size: 13px">{{item.py}}</span>
                  <span style="float: left">{{item.name}}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="country.length > 0" style="width:15%">
            <el-select v-model="query.countyid" filterable clearable placeholder="请选择区域/县城" @change="changearea">	          
              <el-option v-for="(item,index) in country" :label="item.showname" :value="item.id" :key="index">
                  <span style="float: left;margin-right:10%;font-size: 13px">{{item.py}}</span>
                  <span style="float: left">{{item.name}}</span>
              </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item>
              <!--
              <el-button type="primary" icon="el-icon-search" @click="getaddresslists">查询</el-button>
              -->
              <el-button type="danger" icon="el-icon-plus" @click="addtemp">新增</el-button>
              <el-button type="primary" icon="el-icon-search" @click="getweightlists">重量管理</el-button>
              <el-tooltip content="收起、展开默认邮费模板" placement="top">
                  <el-button type="success" size="mini" icon="el-icon-d-caret" circle @click="showandclosedefault"></el-button>
              </el-tooltip>
          </el-form-item>   
      </el-form>
      </div>

      <el-tag type="danger" style="margin-top:10px">温馨提示：该功能用于分销商品下单后订单不满足免邮条件时使用，暂时不适用于线上商城下单，因线上商城下单设置有起送金额</el-tag>
      
      <!-- 默认模板设置 -->
      <div v-loading="adsloading" class="defaulttemp" :style="defaultheight">
      <div class="singleaddress" v-for="(item,index) in addresslists" v-if="item.provinceid==0">
          <el-col :span="24" style="margin-bottom:15px">
              <el-col :span="14"><a href="javascript:;" class="addressinfos" @click="gochildcity(item)">{{item.name}}</a></el-col>
              <el-col :span="10" align="right">
                <el-button type="success" icon="el-icon-d-caret" circle size="mini" class="hb" v-if="item.weights.length > 0" @click="casweight(index)"></el-button>
                <!--
                <el-button type="danger" icon="el-icon-delete" circle size="mini" class="hb" v-if="item.weights.length > 0"></el-button>
                -->
                <el-button type="warning" icon="el-icon-edit" circle size="mini" class="hb" @click="editaddress(item)"></el-button>
              </el-col>
          </el-col>
          <div class="weightout" :style="addressheight[index]">
          <el-col :span="24" v-for="(t,i) in item.weights" :key="i">
              <el-col :span="18">{{t.weightname}} kg</el-col>
              <el-col :span="6" align="right">{{t.price}}</el-col>
          </el-col>
          </div>
      </div>
      <div style="float:left;margin-left:2%;margin-top:3rem"><el-tag type="danger">温馨提示：默认运费模板设置用于系统模板尚未覆盖的区域（未添加的区域）</el-tag></div>
      </div>
      
      <!-- 中间隔断层 -->
      <div class="localadress">
          <img src="../../assets/adressicon.png" />
          <span>当前地区：{{localcity}}</span>
          <el-button type="success" size="mini" icon="el-icon-arrow-up" circle @click="gouplocal"></el-button>
      </div>

      <!-- 通用模板设置 -->
      <div v-loading="adsloading" style="float:left;width:100%;margin-bottom:1rem">
      <div class="singleaddress" v-for="(item,index) in addresslists" v-if="item.provinceid > 0">
          <el-col :span="24" style="margin-bottom:15px">
              <el-col :span="14"><a href="javascript:;" class="addressinfos" @click="gochildcity(item)">{{item.name}}</a></el-col>
              <el-col :span="10" align="right">
                <el-button type="success" icon="el-icon-d-caret" circle size="mini" class="hb" v-if="item.weights.length > 0" @click="casweight(index)"></el-button>
                <!--
                <el-button type="danger" icon="el-icon-delete" circle size="mini" class="hb" v-if="item.weights.length > 0"></el-button>
                -->
                <el-button type="warning" icon="el-icon-edit" circle size="mini" class="hb" @click="editaddress(item)"></el-button>
              </el-col>
          </el-col>
          <div class="weightout" :style="addressheight[index]">
          <el-col :span="24" v-for="(t,i) in item.weights" :key="i">
              <el-col :span="18">{{t.weightname}} kg</el-col>
              <el-col :span="6" align="right">{{t.price}}</el-col>
          </el-col>
          </div>
      </div>
      </div>

      <!-- 新增邮费模板 -->
      <el-dialog title="新增邮费模板" :visible.sync="tempDialog" width="35%" top="10vh">
          <div style="width:100%;border-bottom:1px solid rgb(221,221,221,.4);margin-bottom:10px">地址信息</div>
          <div v-loading="addaddressloading">    
          <el-form :inline="true" size="small">
              <el-form-item v-if="addprovincelists.length > 0" style="width:45%">
                <el-select v-model="addquery.provinceid" filterable clearable placeholder="请选择省份" @change="addchangeprovince">	          
                  <el-option v-for="(item,index) in addprovincelists" :label="item.showname" :value="item.id" :key="index">
                      <span style="float: left;margin-right:10%;font-size: 13px">{{item.py}}</span>
                      <span style="float: left">{{item.name}}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="addcitylists.length > 0" style="width:45%">
                <el-select v-model="addquery.cityid" filterable clearable placeholder="请选择市区" @change="addchangecity">	          
                  <el-option v-for="(item,index) in addcitylists" :label="item.showname" :value="item.id" :key="index">
                      <span style="float: left;margin-right:10%;font-size: 13px">{{item.py}}</span>
                      <span style="float: left">{{item.name}}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="addtownlists.length > 0" style="width:45%">
                <el-select v-model="addquery.townid" filterable clearable placeholder="请选择区域/县城" @change="addchangetown">	          
                  <el-option v-for="(item,index) in addtownlists" :label="item.showname" :value="item.id" :key="index">
                      <span style="float: left;margin-right:10%;font-size: 13px">{{item.py}}</span>
                      <span style="float: left">{{item.name}}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="addcountry.length > 0" style="width:45%">
                <el-select v-model="addquery.countyid" filterable clearable placeholder="请选择区域/县城">	          
                  <el-option v-for="(item,index) in addcountry" :label="item.showname" :value="item.id" :key="index">
                      <span style="float: left;margin-right:10%;font-size: 13px">{{item.py}}</span>
                      <span style="float: left">{{item.name}}</span>
                  </el-option>
                </el-select>
              </el-form-item>
          </el-form>

          <div style="width:100%;border-bottom:1px solid rgb(221,221,221,.4);margin:30px 0 10px 0;padding-bottom:5px">
              重量信息<el-button type="danger" size="mini" circle icon="el-icon-plus" style="float:right;" @click="addweight"></el-button>
          </div>

          <div v-for="(item,index) in addquery.weights" :key="index" style="float:left;width:100%;padding:10px 0 10px 0;border-bottom:1px solid rgb(221,221,221,.4)">
              <el-input v-model="item.weight" size="small" style="float:left;width:40%;margin-right:10%" placeholder="请选择重量规格" @focus="selectweight(index,'add')"><template slot="append">kg</template></el-input>
              <el-input v-model="item.price" size="small" style="float:left;width:25%;margin-right:15%" placeholder="请填写价格"></el-input>
              <el-button type="danger" icon="el-icon-delete" circle size="mini" style="float:right;" @click="delweights(index,'add')"></el-button>
          </div>

          </div>
          <div slot="footer" class="dialog-footer">
              <el-button size="medium" @click="tempDialog=false" style="margin-top:20px">取 消</el-button>
              <el-button size="medium" type="primary" @click="savetemp" style="margin-top:20px">保存</el-button>
          </div>  
      </el-dialog>


      <!-- 编辑区域邮费模板 -->
      <el-dialog title="编辑邮费模板" :visible.sync="editDialog" width="35%" top="10vh">
          <div style="width:100%;border-bottom:1px solid rgb(221,221,221,.4);margin-bottom:10px">地址信息</div>
          <div class="float:left;width:100%">{{editaddressquery.name}}</div>

          <div style="width:100%;border-bottom:1px solid rgb(221,221,221,.4);margin:30px 0 10px 0;padding-bottom:5px">
              重量信息<el-button type="danger" size="mini" circle icon="el-icon-plus" style="float:right;" @click="addeditweight"></el-button>
          </div>

          <div v-for="(item,index) in editaddressquery.weights" :key="index" style="float:left;width:100%;padding:10px 0 10px 0;border-bottom:1px solid rgb(221,221,221,.4)">
              <el-input v-model="item.weight" size="small" style="float:left;width:40%;margin-right:10%" placeholder="请选择重量规格" @focus="selectweight(index,'edit')"><template slot="append">kg</template></el-input>
              <el-input v-model="item.price" size="small" style="float:left;width:25%;margin-right:15%" placeholder="请填写价格"></el-input>
              <el-button type="danger" icon="el-icon-delete" circle size="mini" style="float:right;" @click="delweights(index,'edit')"></el-button>
          </div>
          <div slot="footer" class="dialog-footer">
              <el-button size="medium" @click="editDialog=false" style="margin-top:20px">取 消</el-button>
              <el-button size="medium" type="primary" @click="saveeidttemp" style="margin-top:20px">保存</el-button>
          </div>  
      </el-dialog>


      <!-- 选择重量信息 -->
      <el-dialog title="选择重量信息" :visible.sync="selectDialog" width="25%" top="15vh">
          <el-table :data="weightdatas" v-loading="selectloading">
	          <el-table-column prop="name" label="重量信息（kg）"></el-table-column>	          
	          <el-table-column label="操作" align="center">
		          <template slot-scope="scope">
		              <el-button type="success" size="small" icon="el-icon-check"  circle @click="selectwg(scope.row)"></el-button>
		          </template>
	          </el-table-column>
	      </el-table>
      </el-dialog>

  </div>
  </transition>   
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Shippingtemp/index",
      transitionshow:true,
      tempDialog:false,
      provincelists:[],
      citylists:[],
      townlists:[],
      country:[],
      addressloading:false,
      adsloading:false,
      query: {
          act:'templists',
          token:this.$cookies.get('token'),
          provinceid:'',
          cityid:'',
          townid:'',
          countyid:'',
          weightid:'',
	    },
      addresslists:[],
      
      addprovincelists:[],
      addcitylists:[],
      addtownlists:[],
      addcountry:[],
      addaddressloading:false,
      addquery: {
          act:'addtemp',
          token:this.$cookies.get('token'),
          provinceid:'',
          provincename:'',
          cityid:'',
          cityname:'',
          townid:'',
          townname:'',
          countyid:'',
          countyname:'',
          weights:[],
	    },
      selectDialog:false,
      selectloading:false,
      weightdatas:[],
      weightindex:'',
      weighttype:'',
      addressheight:[],

      editDialog:false,
      editLoading:false,
      editaddressquery: {
          act:'saveedittemp',
          token:this.$cookies.get('token'),
          name:'',
          provinceid:'',
          cityid:'',
          townid:'',
          countyid:'',
          provincename:'',
          cityname:'',
          townname:'',
          countyname:'',
          weights:[],
      },
      localcity:'',
      defaultheight: {'max-height':'100rem'},
    }  
  },
  mounted(){
      this.getProvince(); //获取京东省份信息
      this.getaddresslists(); //获取区域配送规格
  },
  methods:{

      /** 展开/收起邮费模板 **/
      showandclosedefault() {
          this.defaultheight['max-height']==0 ? this.defaultheight['max-height']='100rem' : this.defaultheight['max-height']=0;
      },
	  
  	  /** 邮费模板重量信息管理 **/
  	  getweightlists() {
		  this.$emit('listenchild',{name:'重量管理',url:'Shippingweight'});
      },

      /** 获取区域配送规格 **/
      getaddresslists() {
          var _this=this;
          this.adsloading=true;
          this.addresslists=[];
          this.addressheight=[];

          //获取当前位置名称
          if(this.query.provinceid==0) this.localcity='全国';
          if(this.query.provinceid > 0 && this.query.cityid=='') { //当前位置为省份
              this.provincelists.forEach(function(item,i) {
                  if(item.id==_this.query.provinceid) _this.localcity=item.name;
              });

          }else if(this.query.cityid > 0 && this.query.townid=='') { //当前位置为二级市
              this.citylists.forEach(function(item,i) {
                  if(item.id==_this.query.cityid) _this.localcity=item.name;
              });

          }else if(this.query.townid > 0 && this.query.countyid=='') { //当前位置为区域/县城
              this.townlists.forEach(function(item,i) {
                  if(item.id==_this.query.townid) _this.localcity=item.name;
              });

          }else if(this.query.countyid > 0) { //当前位置为县/乡镇
              this.country.forEach(function(item,i) {
                  if(item.id==_this.query.countyid) _this.localcity=item.name;
              });

          }

          /**************************************************************************/

          var resource = this.$resource(this.url);
          resource.query(this.query).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.adsloading=false;
              }else{
                  this.addresslists = JSON.parse(Base64.decode(res.data.Data));
                  this.adsloading=false;
                  this.addresslists.forEach(function(item,index) {
                      _this.addressheight.push({'max-height':0,overflow:'hidden',transition:'all .3s','line-height':'2rem'});
                  });
              }
          }).catch((res) => {
              this.adsloading=false;
          });
      },

      /** 返回上一级 **/
      gouplocal() {
          if(this.query.provinceid=='') return false;
          if(this.query.provinceid > 0 && this.query.cityid=='') { //当前为省份返回全国
              this.query.provinceid='';
              this.citylists=[];
              this.townlists=[];
              this.country=[];
          }else if(this.query.cityid > 0 && this.query.townid=='') { //当前为二级市返回省份
              this.query.cityid='';
              this.townlists=[];
              this.country=[];
          }else if(this.query.townid > 0 && this.query.countyid=='') { //当前为区域/县份返回二级市
              this.query.townid='';
              this.country=[];
          }else if(this.query.countyid > 0) { //当前区域为县份/乡镇返回 区域
              this.query.countyid='';
          }

          this.getaddresslists();
      },

      /** 查看下面城市地址信息 **/
      gochildcity(item) {
          item.provinceid==0 ? this.query.provinceid='' : this.query.provinceid=Number(item.provinceid);
          item.cityid==0 ? this.query.cityid='' : this.query.cityid=Number(item.cityid);
          item.townid==0 ? this.query.townid='' : this.query.townid=Number(item.townid);
          item.countyid==0 ? this.query.countyid='' : this.query.countyid=Number(item.countyid);
          
          if(item.provinceid > 0 && item.cityid==0) this.getCity();
          if(item.cityid > 0 && item.townid==0) this.gettown();
          if(item.townid > 0 && item.countyid==0) this.getarea();

          this.getaddresslists();
      },


      /** 新增邮费模板 **/
      addtemp() {
          this.addprovincelists=[];
          this.addcitylists=[];
          this.addtownlists=[];
          this.addcountry=[];
          this.addquery.provinceid='';
          this.addquery.provincename='';
          this.addquery.cityid='';
          this.addquery.cityname='';
          this.addquery.townid='';
          this.addquery.townname='';
          this.addquery.countyid='';
          this.addquery.countyname='';
          this.addquery.weights=[];
          this.tempDialog=true;
          this.addgetProvince(); //获取京东省份信息
      },

      /** 获取京东省份信息 **/
      getProvince() {
        this.addressloading=true;
        var resource = this.$resource(this.GLOBAL.domain+"Product/index");	
          resource.query({act:'getjdaddressinfos',type:1,token:this.$cookies.get('token')}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                this.addressloading=false;
              }else{
                  this.provincelists = JSON.parse(Base64.decode(res.data.Data));
                  this.addressloading=false;
              }
          }).catch((res) => {
              this.addressloading=false;	
          });
      },

      /** 修改已选中的京东的省份信息 **/
      changeprovince() {
        this.query.cityid='';
        this.query.townid='';
        this.query.countyid='';
        this.citylists=[];
        this.townlists=[];
        this.country=[];
        if(this.query.provinceid > 0) this.getCity();
        this.getaddresslists();
      },

      /** 获取京东城市信息 **/
      getCity() {
        this.addressloading=true;
        var resource = this.$resource(this.GLOBAL.domain+"Product/index");	
          resource.query({act:'getjdaddressinfos',type:2,id:this.query.provinceid,token:this.$cookies.get('token')}).then((res) => {
                if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                    this.addressloading=false;
                }else{
                    this.citylists = JSON.parse(Base64.decode(res.data.Data));
                    this.addressloading=false;
                }
          }).catch((res) => {
              this.addressloading=false;  	
          });
      },

      /** 修改已选中的京东城市信息 **/
      changecity() {
        this.query.townid='';
        this.query.countyid='';
        this.townlists=[];
        this.country=[];
        if(this.query.cityid > 0) this.gettown();
        this.getaddresslists();
      },

      /** 获取京东区域地址信息 **/
      gettown() {
        this.addressloading=true;
        var resource = this.$resource(this.GLOBAL.domain+"Product/index");	
          resource.query({act:'getjdaddressinfos',type:3,id:this.query.cityid,token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
            this.addressloading=false;
          }else{
              this.townlists = JSON.parse(Base64.decode(res.data.Data));
            if(this.townlists.length==0) this.query.townid=0;
            this.addressloading=false;
          }
          }).catch((res) => {
              this.addressloading=false;  	
          });
      },

      /** 修改已选中的京东区域/县城信息 **/
      changetown() {
        this.query.countyid='';
        this.country=[];
        if(this.query.townid > 0) this.getarea();
        this.getaddresslists();
      },

      /** 获取区域/乡镇信息 **/
      getarea() {
        this.addressloading=true;
        var resource = this.$resource(this.GLOBAL.domain+"Product/index");	
          resource.query({act:'getjdaddressinfos',type:4,id:this.query.townid,token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
            this.addressloading=false;
          }else{
              this.country = JSON.parse(Base64.decode(res.data.Data));
            if(this.country.length==0) this.query.countyid=0;
            this.addressloading=false;
          }
          }).catch((res) => {
              this.addressloading=false;
          });
      },

      changearea() {
          this.getaddresslists();
      },

      /****************************** 地址信息（新增模板用） ***********************************/
      /** 获取京东省份信息 **/
      addgetProvince() {
        this.addaddressloading=true;
        var resource = this.$resource(this.GLOBAL.domain+"Product/index");	
          resource.query({act:'getjdaddressinfos',type:1,token:this.$cookies.get('token')}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.addaddressloading=false;
              }else{
                  this.addprovincelists = JSON.parse(Base64.decode(res.data.Data));
                  this.addaddressloading=false;
              }
          }).catch((res) => {
              this.addaddressloading=false;	
          });
      },

      /** 修改已选中的京东的省份信息 **/
      addchangeprovince() {
        this.addquery.cityid='';
        this.addquery.townid='';
        this.addquery.countyid='';

        this.addcitylists=[];
        this.addtownlists=[];
        this.addcountry=[];
        if(this.addquery.provinceid > 0) this.addgetCity();
      },

      /** 获取京东城市信息 **/
      addgetCity() {
        this.addaddressloading=true;
        var resource = this.$resource(this.GLOBAL.domain+"Product/index");	
          resource.query({act:'getjdaddressinfos',type:2,id:this.addquery.provinceid,token:this.$cookies.get('token')}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.addaddressloading=false;
              }else{
                  this.addcitylists = JSON.parse(Base64.decode(res.data.Data));
                  this.addaddressloading=false;
              }
          }).catch((res) => {
              this.addaddressloading=false;  	
          });
      },

      /** 修改已选中的京东城市信息 **/
      addchangecity() {
        this.addquery.townid='';
        this.addquery.countyid='';
        this.addtownlists=[];
        this.addcountry=[];
        if(this.addquery.cityid > 0) this.addgettown();
      },

      /** 获取京东区域地址信息 **/
      addgettown() {
        this.addaddressloading=true;
        var resource = this.$resource(this.GLOBAL.domain+"Product/index");	
          resource.query({act:'getjdaddressinfos',type:3,id:this.addquery.cityid,token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.addaddressloading=false;
          }else{
              this.addtownlists = JSON.parse(Base64.decode(res.data.Data));
              if(this.addtownlists.length==0) this.addquery.townid=0;
              this.addaddressloading=false;
          }
          }).catch((res) => {
              this.addaddressloading=false;  	
          });
      },

      /** 修改已选中的京东区域/县城信息 **/
      addchangetown() {
        this.addquery.countyid='';
        this.addcountry=[];
        if(this.addquery.townid > 0) this.addgetarea();
      },

      /** 获取区域/乡镇信息 **/
      addgetarea() {
        this.addaddressloading=true;
        var resource = this.$resource(this.GLOBAL.domain+"Product/index");	
            resource.query({act:'getjdaddressinfos',type:4,id:this.addquery.townid,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.addaddressloading=false;
            }else{
                this.addcountry = JSON.parse(Base64.decode(res.data.Data));
                if(this.addcountry.length==0) this.addquery.countyid=0;
                this.addaddressloading=false;
            }
          }).catch((res) => {
              this.addaddressloading=false;
          });
      },
      /******************************* 地址信息（新增模板用） *************************************/


      /** 新增重量信息 **/
      addweight() {
          this.addquery.weights.push({weightid:'',weight:'',price:''});
      },

      /** 编辑页面新增重量信息 **/
      addeditweight() {
          this.editaddressquery.weights.push({weightid:'',weight:'',price:''});
      },

      /** 删除重量信息 **/
      delweights(index,type) {
          if(type=='add') this.addquery.weights.splice(index,1);
          if(type=='edit') this.editaddressquery.weights.splice(index,1);
      },

      /** 获取重量信息列表 **/
      selectweight(index,type) {
          this.weightindex=index;
          this.weighttype=type;

          var ids=[];
          var _this=this;
          if(type=='add') this.addquery.weights.forEach(function(item,i) {item.weightid > 0 ? ids.push(item.weightid) : '';});
          if(type=='edit') this.editaddressquery.weights.forEach(function(item,i) {item.weightid > 0 ? ids.push(item.weightid) : '';});

          this.selectDialog=true;
          this.selectloading=true;
          var resource = this.$resource(this.url);
          resource.save({act:'selectweights',token:this.$cookies.get('token'),ids:ids}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.selectloading=false;
              }else{
                  this.weightdatas = JSON.parse(Base64.decode(res.data.Data));
                  this.selectloading=false;
              }
          }).catch((res) => {
              this.selectloading=false;
          }); 
      },

      //确认选择重量信息
      selectwg(item) {
          if(this.weighttype=='add') this.addquery.weights[this.weightindex].weightid=item.id;
          if(this.weighttype=='add') this.addquery.weights[this.weightindex].weight=item.name;
          if(this.weighttype=='edit') this.editaddressquery.weights[this.weightindex].weightid=item.id;
          if(this.weighttype=='edit') this.editaddressquery.weights[this.weightindex].weight=item.name;
          this.selectDialog=false;
      },


      //保存重量信息
      savetemp() {
          var _this=this;
          this.addprovincelists.forEach(function(item,i) {if(item.id==_this.addquery.provinceid) _this.addquery.provincename=item.name;});
          this.addcitylists.forEach(function(item,i) {if(item.id==_this.addquery.cityid) _this.addquery.cityname=item.name;});
          this.addtownlists.forEach(function(item,i) {if(item.id==_this.addquery.townid) _this.addquery.townname=item.name;});
          this.addcountry.forEach(function(item,i) {if(item.id==_this.addquery.countyid) _this.addquery.countyname=item.name;});

          var resource = this.$resource(this.url);
          resource.save(this.addquery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  //刷新当前页面
                  this.tempDialog=false;
                  this.getaddresslists();
              }
          }).catch((res) => {
              
          }); 
      },

      /** 展开/收缩重量信息 **/
      casweight(index) {
          var height=this.addressheight[index]['max-height'];
          height==0 ? this.addressheight[index]['max-height']="100rem" : this.addressheight[index]['max-height']=0;
      },

      /** 获取当前地址信息 **/
      editaddress(item) {
          this.editDialog=true;
          this.editLoading=true;
          this.editaddressquery.name=item.name;
          this.editaddressquery.provinceid=item.provinceid;
          this.editaddressquery.cityid=item.cityid;
          this.editaddressquery.townid=item.townid;
          this.editaddressquery.countyid=item.countyid;
          this.editaddressquery.provincename=item.provincename;
          this.editaddressquery.cityname=item.cityname;
          this.editaddressquery.townname=item.townname;
          this.editaddressquery.countyname=item.countyname;
          this.editaddressquery.weights=[];

          //获取系统里重量信息
          var resource = this.$resource(this.url);
          resource.query({act:'getaddressinfos',token:this.$cookies.get('token'),provinceid:item.provinceid,cityid:item.cityid,townid:item.townid,countyid:item.countyid}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.editLoading=false;
              }else{
                  this.editLoading=false;
                  var result = JSON.parse(Base64.decode(res.data.Data));
                  this.editaddressquery.weights=result;
              }
          }).catch((res) => {
              this.editLoading=false;
          }); 
      },

      /** 保存编辑的邮费模板信息 **/
      saveeidttemp() {
          //获取系统里重量信息
          var resource = this.$resource(this.url);
          resource.save(this.editaddressquery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.editDialog=false;
                  this.getaddresslists();
              }
          }).catch((res) => {
              
          }); 
      },

  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.singleaddress {background:#fff;border-radius:5px;border:1px solid #ddd;padding:2% 1% 2% 1%;float:left;width:21.5%;margin:10px 1% 10px 0;transition:all .3s}
.singleaddress:hover {box-shadow: 8px 8px 5px rgb(211,211,211);}
.addressinfos {font-size:.9rem;color:#606266;text-decoration:none;float:left;width:100%}
.hb {float:right;margin-right:5px}
.singleaddress .el-button+.el-button {margin-left:0}
.weightout {float:left;width:100%;border-top:1px solid rgb(211,211,211,.4);padding-top:10px;font-size:.8rem;color:#606266}
.localadress {float:left;width:100%;border-bottom:1px solid rgb(211,211,211,.6);margin:30px 0 10px 0;font-size:.9rem;color:#333;padding-bottom:5px}
.localadress img {float:left;width:1.3rem;height:1.3rem;margin-top:.3rem}
.localadress span {float:left;margin-left:5px;margin-top:.3rem}
.localadress button {float:left;margin-left:2%;}
.defaulttemp {float:left;width:100%;overflow:hidden;transition:all .3s}
</style>


// WEBPACK FOOTER //
// src/components/mall/Shippingtemp.vue